export const SELF = 'SELF';
export const TEAMS = 'TEAMS';
export const KITS = 'KITS';
export const OBJECTS = 'OBJECTS';
export const SET_OBJECT = 'SET_OBJECT';
export const RESET_OBJECT = 'RESET_OBJECT';
export const LOADING = 'LOADING';
export const SET_CURRENT_FRAME = 'SET_CURRENT_FRAME';
export const SET_BACKGROUND = 'SET_BACKGROUND';
export const RESET = 'RESET';
export const RESET_DETECT_FOR_EDITING = 'RESET_DETECT_FOR_EDITING';
export const RESET_EVENTS_NEW = 'RESET_EVENTS_NEW';
export const RESET_FIELD_DATA = 'RESET_FIELD_DATA';
export const SET_CANVAS_SIZE = 'SET_CANVAS_SIZE';
export const SET_DETECT_FOR_EDITING = 'SET_DETECT_FOR_EDITING';
export const SET_DETECT_LABELS = 'SET_DETECT_LABELS';
export const SET_EVENT = 'SET_EVENT';
export const SET_EVENT_FILTER = 'SET_EVENT_FILTER';
export const SET_EVENT_SEARCH = 'SET_EVENT_SEARCH';
export const SET_EVENT_TYPES = 'SET_EVENT_TYPES';
export const SET_EVENT_LOADING = 'SET_EVENT_LOADING';
export const SET_EVENTS = 'SET_EVENTS';
export const SET_EVENTS_LOADING = 'SET_EVENTS_LOADING';
export const SET_EVENTS_NEW = 'SET_EVENTS_NEW';
export const SET_EVENTS_PAGE = 'SET_EVENTS_PAGE';
export const SET_GAME_STATISTICS_LOADING = 'SET_GAME_STATISTICS_LOADING';
export const SET_PLAYERS_STATISTICS_LOADING = 'SET_PLAYERS_STATISTICS_LOADING';
export const SET_INTERPOLATED_VISIBILITY = 'SET_INTERPOLATED_VISIBILITY';
export const SET_LOGS = 'SET_LOGS';
export const SET_LOGS_LOADING = 'SET_LOGS_LOADING';
export const SET_LOGS_LOOP = 'SET_LOGS_LOOP';
export const SET_DETECTS_TYPE = 'SET_DETECTS_TYPE';
export const SET_FIELD_DATA = 'SET_FIELD_DATA';
export const SET_FIELD_LABEL_VISIBILITY = 'SET_FIELD_LABEL_VISIBILITY';
export const SET_FILTERED_DETECTS = 'SET_FILTERED_DETECTS';
export const SET_PREVIOUS_NEW_DETECT = 'SET_PREVIOUS_NEW_DETECT';
export const SET_SHOW_ONLY_DETECT = 'SET_SHOW_ONLY_DETECT';
export const SET_ACTION = 'SET_ACTION';
export const SET_STATISTICS = 'SET_STATISTICS';
export const SET_TEAM_SHAPES_VISIBILITY = 'SET_TEAM_SHAPES_VISIBILITY';
export const SET_VIEW = 'SET_VIEW';
export const SET_VISIBILITY_CANVAS = 'SET_VISIBILITY_CANVAS';
export const SET_VISIBILITY_LINEUPS = 'SET_VISIBILITY_LINEUPS';

export default {
  SELF,
  TEAMS,
  KITS,
  OBJECTS,
  SET_OBJECT,
  RESET_OBJECT,
  LOADING,
  RESET_DETECT_FOR_EDITING,
  RESET_EVENTS_NEW,
  RESET_FIELD_DATA,
  SET_CURRENT_FRAME,
  SET_BACKGROUND,
  SET_CANVAS_SIZE,
  SET_DETECT_FOR_EDITING,
  SET_DETECT_LABELS,
  SET_EVENT,
  SET_EVENT_FILTER,
  SET_EVENT_SEARCH,
  SET_EVENT_TYPES,
  SET_EVENT_LOADING,
  SET_EVENTS,
  SET_EVENTS_LOADING,
  SET_EVENTS_NEW,
  SET_EVENTS_PAGE,
  SET_GAME_STATISTICS_LOADING,
  SET_PLAYERS_STATISTICS_LOADING,
  SET_INTERPOLATED_VISIBILITY,
  SET_LOGS,
  SET_LOGS_LOADING,
  SET_LOGS_LOOP,
  SET_DETECTS_TYPE,
  SET_FIELD_DATA,
  SET_FIELD_LABEL_VISIBILITY,
  SET_FILTERED_DETECTS,
  SET_PREVIOUS_NEW_DETECT,
  SET_SHOW_ONLY_DETECT,
  RESET,
  SET_ACTION,
  SET_STATISTICS,
  SET_TEAM_SHAPES_VISIBILITY,
  SET_VIEW,
  SET_VISIBILITY_CANVAS,
  SET_VISIBILITY_LINEUPS,
};
